import _ from 'lodash';

function checkMatchingStatus(change, current, match) {
  if (Object.keys(change).length >= Object.keys(current).length) {
    const pickChange = _.pick(change, Object.keys(current));
    const omitChange = _.values(_.omit(change, Object.keys(current)));

    if (match) {
      if (omitChange.every((change) => !change)) {
        return _.isMatch(pickChange, current);
      } else {
        return false;
      }
    } else {
      if (omitChange.every((change) => !change)) {
        return !_.isMatch(pickChange, current);
      } else {
        return true;
      }
    }
  } else {
    const pickCurrent = _.pick(current, Object.keys(change));
    // const omitCurrent = _.values(_.omit(current, Object.keys(change)))

    if (match) {
      //   if (omitCurrent.every((current) => !current)) {
      //     return _.isMatch(pickCurrent, change)
      //   } else {
      //     return false
      //   }
      return _.isMatch(pickCurrent, change);
    } else {
      //   if (omitCurrent.every((current) => !current)) {
      //     return !_.isMatch(pickCurrent, change)
      //   } else {
      //     return true
      //   }
      return !_.isMatch(pickCurrent, change);
    }
  }
}

export default checkMatchingStatus;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/checkMatchingStatus.js